import { OrderUser } from '.';

export class SplMergeInput {
  splVersionNumber: number;
  ValidatedLLRevisionId: number;
  filePath: string;
  fileName: string;
  userProvidedFileName: string;
  mergeFromWorkflowOrderId: number;
  mergeFromOrderRevisionId: number;
  externalTrackingNumber: string;
  orderOwner: OrderUser;
  orderName: string;
  effectiveDate: Date;
  registrantConfidentiality: string;
}
